import { render, staticRenderFns } from "./Gerencia.vue?vue&type=template&id=5512e0d0&scoped=true"
import script from "./Gerencia.vue?vue&type=script&lang=js"
export * from "./Gerencia.vue?vue&type=script&lang=js"
import style0 from "./Gerencia.vue?vue&type=style&index=0&id=5512e0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5512e0d0",
  null
  
)

export default component.exports